import { marketIntelligenceContent } from '@/config/marketing-content/feature-pages'
import { FeatureMarketingPage } from '@/components/marketing/feature-marketing-page'

export function MarketIntelligencePage() {
  return <FeatureMarketingPage content={marketIntelligenceContent} />
}
